export const SITE_INFO = {
  brandName: 'Notemaster',
  legalName: 'Notemaster',
  cityRegion: 'Duque de Caxias - RJ',
  supportEmail: 'suporte@notemaster89.com.br',
  phone: {
    display: '(21) 994023817',
    tel: '21994023817',
  },
  whatsapp: {
    // Formato E.164 sem +
    number: '5521994023817',
    display: '(21) 99402 3817',
  },
  address: {
    street: 'Estrada da Várzea, 25 - Qd.01',
    neighborhood: 'Vila Santa Cruz',
    city: 'Duque de Caxias',
    state: 'RJ',
    postalCode: '25260-160',
    country: 'BR',
  },
  businessHours: {
    // Conteúdo (site/chatbot) — se mudar aqui, mudar também no backend/data/faq.json
    weekdays: 'Segunda a sexta: 9h às 18h',
    saturday: 'Sábado: 10h às 14h',
  },
  payments: [
    'PIX',
    'Dinheiro',
    'Cartão de crédito (até 10x, com taxas do parcelamento)',
    'Cartão de débito',
  ],
  warranty: {
    headline: 'Garantia padrão de 90 dias',
    details:
      'Garantia padrão de 90 dias em serviços e peças substituídas. Em alguns serviços, a garantia pode variar e será informada no orçamento.',
  },
  leadTime: {
    quote: 'Orçamento geralmente em até 48h (conforme complexidade)',
    delivery: 'Prazo de entrega geralmente de 3 a 7 dias úteis (conforme reparo/peças)',
  },
  serviceArea:
    'Atendimento presencial em Duque de Caxias - RJ. Atendimento externo apenas para contratantes (sob consulta).',
};

export function getWhatsAppUrl(message) {
  const base = `https://wa.me/${SITE_INFO.whatsapp.number}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export function getGoogleMapsDirectionsUrl() {
  const destination = `${SITE_INFO.address.street}, ${SITE_INFO.address.neighborhood}, ${SITE_INFO.address.city} - ${SITE_INFO.address.state}, ${SITE_INFO.address.postalCode}`;
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
}

